import { PalmettoButton, PalmettoIcon } from '@palmetto/dsm-components';
import { useCallback, useMemo, type FC } from 'react';
import { useFieldArray, type Control, type UseFormSetValue } from 'react-hook-form';

import type { DialogFormValues } from './checklistItemInputOptions';
import { FlagMappingRow } from './FlagMappingRow';
import { useFlagSettings } from './FlagSettingsContext';

export interface OptionFlagMappingEditorProps {
  inputIndex: number;
  optionIndex: number;
  control: Control<DialogFormValues>;
  setValue: UseFormSetValue<DialogFormValues>;
}

export const OptionFlagMappingEditor: FC<OptionFlagMappingEditorProps> = ({
  inputIndex,
  optionIndex,
  control,
  setValue,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: `inputs.${inputIndex}.options.${optionIndex}.flagMappings`,
  });

  const settingsLoaded = useFlagSettings().length > 0;

  const handleAdd = useCallback(() => append({ requirementFlagSettingId: '' }), [append]);
  const addIcon = useMemo(() => <PalmettoIcon name="add" size="xs" />, []);

  return (
    <div className="mb-4 ml-8">
      {fields.map((field, mappingIndex) => (
        <FlagMappingRow
          key={`${field.id}|${settingsLoaded}`}
          inputIndex={inputIndex}
          optionIndex={optionIndex}
          mappingIndex={mappingIndex}
          control={control}
          setValue={setValue}
          remove={remove}
        />
      ))}
      <PalmettoButton
        type="button"
        emphasis="tertiary"
        size="small"
        layout="hug"
        onClick={handleAdd}
        leadingIcon={addIcon}
      >
        Flag mapping
      </PalmettoButton>
    </div>
  );
};
